import consultationRequestAPI from '../../api/consultation_request'
import StoreInit from '../../api/initialise_store'
import { vipSort, cancelRequestSort, generalRequestSort, mergeRequests } from '../../helpers/request_sort'
// import Vue from 'vue'
// State

const state = {
  requests: [],
  followUpQuestions: [],
  loadDetails: [],
  setRequests: [],
  snackbarRequests: []
}

// Getters
const getters = {
  getRequests () {
    let jsonRequests = state.requests.map(JSON.stringify)
    let requestSet = new Set(jsonRequests)
    state.requests = Array.from(requestSet).map(JSON.parse)
    return state.requests.filter(function (ele) {
      return (ele.status === 'unicasted' || ele.status === 'broadcasted' || ele.status === 'queried')
    })
  },
  getQueries () {
    return state.requests.filter(function (ele) {
      return (ele.status === 'queried' && ele.request_type === 'queried')
    })
  },
  getMissedRequests () {
    return state.requests.filter(function (ele) {
      return (ele.status === 'queried' && ele.request_type === 'missed')
    })
  },
  getAcceptedRequest () {
    return state.requests.filter(function (ele) {
      return (ele.status === 'accepted')
    })
  },
  getOthersAcceptedRequest () {
    return state.requests.filter(function (ele) {
      return (ele.status === 'already_assigned')
    })
  },
  getCancelledRequest () {
    return state.requests.filter(function (ele) {
      return (ele.status === 'cancelled')
    })
  },
  getRejectedRequest () {
    return state.requests.filter(function (ele) {
      return (ele.status === 'rejected')
    })
  },
  getFollowupQuestions () {
    return state.followUpQuestions
  }
}

// Actions
const actions = {
  init ({ commit, state }, {details}) {
    commit('setUpRequests', {details})
  },

  setUpQueries ({commit}) {
    StoreInit.fetchQueries().then(response => {
      if (response.status === 200) {
        commit('setUpRequests', {details: response.body.consultation_requests})
      }
    })
  },

  addConsultationRequest ({ commit, state, rootState, dispatch }, message) {
    if (message.request_status === 'unicasted') {
      commit('addUnicastedRequest', message)
    } else {
      if (message.family_doctor_id !== rootState.configuration.doctorId) {
        commit('add', message)
      }
    }
  },

  acceptConsultationRequest ({ commit, state, rootState, dispatch }, request) {
    consultationRequestAPI.accept(request.consultationRequestId, rootState.configuration.doctorId).then(response => {
      if (response.status === 200) {
        if (response.body.state === 'assigned') {
          commit('remove', {channelId: request.channelId, status: 'accepted'})
          let consultation = response.body.consultation
          dispatch('consultation/addToActiveConsultation', {request, consultation}, { root: true })
        } else if (response.body.state === 'already_assigned') {
          commit('remove', {channelId: request.channelId, status: 'already_assigned'})
        } else if (response.body.status === 'error') {
          dispatch('toaster/setToaster', {status: true, type: 'error', message: response.body.message}, { root: true })
          commit('remove', {channelId: request.channelId, status: 'already_assigned'})
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  acceptQueriedConsultationRequest ({ commit, state, rootState, dispatch }, request) {
    consultationRequestAPI.acceptQuery(request.consultationRequestId, rootState.configuration.doctorId).then(response => {
      if (response.status === 200) {
        commit('remove', {channelId: request.channelId, status: 'query_accepted'})
        let consultation = response.body.consultation
        dispatch('consultation/addQueryToActiveConsultation', {request, consultation}, { root: true })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  queriedConsultationRequest ({ commit, state, rootState }, message) {
    message.request_type = 'queried'
    commit('addQueriedRequest', message)
  },

  missedConsultationRequest ({ commit, state, rootState }, message) {
    commit('updateMissedReq', {channelId: message.payload.channel_id, status: 'queried', type: 'missed', message: 'Request was missed'})
  },

  removeRequest ({ commit, state }, {message, status}) {
    commit('remove', {channelId: message.payload.channel_id, status: status, message: message.payload.text
    })
  },

  loadDetails ({commit, state}) {
    consultationRequestAPI.load_details().then(response => {
      if (response.status === 200) {
        commit('saveLoadDetails', response.body.details)
      }
    })
  }
}

// Mutations
const mutations = {
  async setUpRequests (state, {details}) {
    if (details.length > 0) {
      let vipList = vipSort(details)
      let cancelledRequestList = cancelRequestSort(details)
      let generalRequestList = generalRequestSort(details)
      let requests = await mergeRequests(vipList, cancelledRequestList, generalRequestList)
      for (let i = 0; i < requests.length; i++) {
        let req = state.requests.find(function (ele) {
          return (ele.customer_id === requests[i].customer_id)
        })
        let index = state.requests.indexOf(req)
        if (index < 0) {
          let request = {
            channelId: requests[i].channel_id,
            customer_id: requests[i].customer_id,
            customer_name: requests[i].customer_name,
            consultationRequestId: requests[i].consultation_request_id,
            status: requests[i].request_status,
            request_type: requests[i].request_type,
            time: requests[i].time,
            chiefComplaint: requests[i].chief_complaint,
            duration: requests[i].duration,
            isFamilyDoctor: requests[i].is_family_doctor,
            familyDoctor: {id: requests[i].family_doctor.id, name: requests[i].family_doctor.name},
            cancelledRequestsCount: requests[i].cancelled_requests_count,
            vip: requests[i].vip
          }
          state.requests.push(request)
        }
      }
    }
  },

  addUnicastedRequest (state, message) {
    let req = state.requests.find(function (ele) {
      return (ele.channelId === message.payload.channel_id && (ele.request_status === 'unicasted' || ele.request_status === 'queried'))
    })
    // let index = state.requests.indexOf(req)
    if (!req) {
      let customerDetails = {
        consultationRequestId: message.consultation_id,
        chiefComplaint: message.chief_complaint,
        duration: message.duration,
        channelId: message.payload.channel_id,
        customer_id: message.payload.customer_id,
        customer_name: message.payload.customer_name,
        status: message.request_status,
        request_type: message.request_type,
        time: message.time,
        isFamilyDoctor: message.is_family_doctor,
        initiatorId: message.payload.initiator_id,
        initiatorName: message.payload.initiator_name,
        cancelledRequestsCount: message.cancelled_requests_count,
        vip: message.vip
      }
      if (state.requests.length === 0) {
        state.requests.push(customerDetails)
        return
      }
      let vipIndex = (state.requests.filter((ele) => ele.vip)).length
      let requestCountLength = vipIndex + (state.requests.filter((ele) => !ele.vip && ele.cancelledRequestsCount > 0)).length
      if (customerDetails.vip) {
        state.requests.splice(vipIndex, 0, customerDetails)
      } else if (customerDetails.cancelledRequestsCount > 0 && !customerDetails.vip) {
        let added = false
        if (state.requests.length === 0) {
          state.requests.push(customerDetails)
        } else {
          for (let i = vipIndex; i < requestCountLength; i++) {
            if (customerDetails.cancelledRequestsCount > state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i, -1, customerDetails)
              added = true
              break
            } else if (customerDetails.cancelledRequestsCount === state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i + 1, 0, customerDetails)
              added = true
            }
          }
          if (!added) {
            state.requests.splice(requestCountLength, -1, customerDetails)
            added = true
          }
        }
        if (!added) {
          state.requests.splice(vipIndex, -1, customerDetails)
        }
      } else {
        state.requests.push(customerDetails)
      }
    }
  },

  add (state, message) {
    let req = state.requests.find(function (ele) {
      return (ele.channelId === message.payload.channel_id && ele.status === 'broadcasted')
    })
    // let index = state.requests.indexOf(req)
    if (!req) {
      let customerDetails = {
        consultationRequestId: message.consultation_id,
        chiefComplaint: message.chief_complaint,
        duration: message.duration,
        channelId: message.payload.channel_id,
        customer_id: message.payload.customer_id,
        customer_name: message.payload.customer_name,
        status: message.request_status,
        time: message.time,
        isFamilyDoctor: message.is_family_doctor,
        familyDoctor: {id: message.family_doctor.id, name: message.family_doctor.name},
        cancelledRequestsCount: message.cancelled_requests_count,
        vip: message.vip
      }
      if (state.requests.length === 0) {
        state.requests.push(customerDetails)
        return
      }
      let vipIndex = (state.requests.filter((ele) => ele.vip)).length
      let requestCountLength = vipIndex + (state.requests.filter((ele) => !ele.vip && ele.cancelledRequestsCount > 0)).length
      if (customerDetails.vip) {
        state.requests.splice(vipIndex, 0, customerDetails)
      } else if (customerDetails.cancelledRequestsCount > 0 && !customerDetails.vip) {
        let added = false
        if (state.requests.length === 0) {
          state.requests.push(customerDetails)
        } else {
          for (let i = vipIndex; i < requestCountLength; i++) {
            if (customerDetails.cancelledRequestsCount > state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i, -1, customerDetails)
              added = true
              break
            } else if (customerDetails.cancelledRequestsCount === state.requests[i].cancelledRequestsCount) {
              state.requests.splice(i + 1, 0, customerDetails)
              added = true
            }
          }
          if (!added) {
            state.requests.splice(requestCountLength, -1, customerDetails)
            added = true
          }
        }
        if (!added) {
          state.requests.splice(vipIndex, -1, customerDetails)
        }
      } else {
        state.requests.push(customerDetails)
      }
      // notification.create('newuser')
    }
  },

  addQueriedRequest (state, message) {
    let req = state.requests.find(function (ele) {
      return (ele.channelId === message.payload.channel_id && (ele.request_status === 'unicasted' || ele.request_status === 'queried'))
    })
    // let index = state.requests.indexOf(req)
    let customerDetails
    if (!req) {
      customerDetails = {
        consultationRequestId: message.consultation_id,
        chiefComplaint: message.chief_complaint,
        duration: message.duration,
        channelId: message.payload.channel_id,
        customer_id: message.payload.customer_id,
        customer_name: message.payload.customer_name,
        status: message.request_status,
        request_type: message.request_type,
        time: message.time,
        isFamilyDoctor: message.is_family_doctor,
        initiatorId: message.payload.initiator_id,
        initiatorName: message.payload.initiator_name,
        cancelledRequestsCount: message.cancelled_requests_count,
        vip: message.vip
      }
      state.requests.push(customerDetails)
    }
    let vipIndex = (state.requests.filter((ele) => ele.vip)).length
    let requestCountLength = vipIndex + (state.requests.filter((ele) => !ele.vip && ele.cancelledRequestsCount > 0)).length
    if (customerDetails.vip) {
      if (vipIndex === 0) {
        state.requests.unshift(customerDetails)
      } else {
        state.requests.splice(vipIndex, 0, customerDetails)
      }
    } else if (customerDetails.cancelledRequestsCount > 0 && !customerDetails.vip) {
      let added = false
      if (state.requests.length === 0) {
        state.requests.push(customerDetails)
      } else {
        for (let i = vipIndex; i < requestCountLength; i++) {
          if (customerDetails.cancelledRequestsCount > state.requests[i].cancelledRequestsCount) {
            state.requests.splice(i, -1, customerDetails)
            added = true
            break
          } else if (customerDetails.cancelledRequestsCount === state.requests[i].cancelledRequestsCount) {
            state.requests.splice(i + 1, 0, customerDetails)
            added = true
          }
        }
        if (!added) {
          state.requests.splice(requestCountLength, -1, customerDetails)
          added = true
        }
      }
      if (!added) {
        state.requests.splice(vipIndex, -1, customerDetails)
      }
    } else {
      state.requests.push(customerDetails)
    }
  },

  updateMissedReq (state, {channelId, status, type, message}) {
    let req = state.requests.find(function (ele) {
      return (ele.channelId === channelId && ele.status === 'unicasted')
    })
    let index = state.requests.indexOf(req)
    if (index > -1) {
      let req = state.requests[index]
      req.status = status
      req.request_type = type
      req.message = message
      state.requests.splice(index, 1)
      state.requests.push(req)
    }
  },

  remove (state, {channelId, status, message}) {
    let req = state.requests.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.requests.indexOf(req)
    if (index > -1) {
      let req = state.requests[index]
      req.status = status
      req.message = message
      state.requests = state.requests.filter((ele) => ele.channelId !== channelId)
      // state.requests.push(req)
    }
  },

  saveLoadDetails (state, details) {
    state.loadDetails = details
  },

  reset (state) {
    state = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/consultation_request.js